module.exports = __webpack_public_path__ + "img/about-banner.5a56ff69.jpg";